import { render, staticRenderFns } from "./ExerciseParamLabelHelper.vue?vue&type=template&id=5e5b1c54"
import script from "./ExerciseParamLabelHelper.vue?vue&type=script&lang=js"
export * from "./ExerciseParamLabelHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports